var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './UsersImportTuto.module.scss';
import { Icons } from 'src/ui/components/Icons/Icons';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { useRef, useState } from 'react';
import classNames from 'classnames';
import { useMount } from 'src/shared/hooks/useLifecycle';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { REQUIRED_CSV_FILE_HEADERS } from 'src/ui/views/users/components/UsersImportModal/constants';
export var UsersImportTuto = function (props) {
    var _a, _b, _c;
    var i18n = props.i18n;
    var _d = useState(false), isTutoOpen = _d[0], setIsTutoOpen = _d[1];
    var _e = useState(0), heightOfTutorial = _e[0], setHeightOfTutorial = _e[1];
    var contentRef = useRef(null);
    var handleHeadClick = function (e) {
        e.stopPropagation();
        setIsTutoOpen(!isTutoOpen);
    };
    var tutoWrapperClass = classNames(styles.UsersImportTutoWrapper, (_a = {},
        _a[styles.UsersImportTutoWrapperOpen] = isTutoOpen,
        _a));
    var tutoHeadClass = classNames(styles.UsersImportTutoHead, (_b = {},
        _b[styles.UsersImportTutoHeadOpen] = isTutoOpen,
        _b));
    var tutoContentClass = classNames(styles.UsersImportTutoContent, (_c = {},
        _c[styles.UsersImportTutoContentOpen] = isTutoOpen,
        _c));
    useMount(function () {
        var contentRefHeight = contentRef.current ? contentRef.current.offsetHeight : 0;
        setHeightOfTutorial(contentRefHeight);
    });
    var handleTutoClick = function (e) {
        e.stopPropagation();
        if (!isTutoOpen) {
            setIsTutoOpen(true);
        }
    };
    var needHelpText = getPropsByKeyPath(i18n, 'components.importUsersModal.helpTitle');
    var formatText = getPropsByKeyPath(i18n, 'components.importUsersModal.content.format');
    var formatFirstLineText = getPropsByKeyPath(i18n, 'components.importUsersModal.content.formatFirstLine');
    var requiredColsText = getPropsByKeyPath(i18n, 'components.importUsersModal.content.requiredCols');
    var groupsFormatText = getPropsByKeyPath(i18n, 'components.importUsersModal.content.groupsFormat');
    var groupsFormatExampleText = getPropsByKeyPath(i18n, 'components.importUsersModal.content.groupsFormatExample');
    var userModifiedAndCreatedText = getPropsByKeyPath(i18n, 'components.importUsersModal.content.userModifiedAndCreated');
    var userDeletedText = getPropsByKeyPath(i18n, 'components.importUsersModal.content.userDeleted');
    return (_jsxs("div", __assign({ className: tutoWrapperClass, onClick: handleTutoClick }, { children: [_jsxs("div", __assign({ className: tutoHeadClass, onClick: handleHeadClick }, { children: [_jsxs("div", __assign({ className: styles.UsersImportTutoEmergedLabel }, { children: [_jsx(Icons, { icon: E_ICONS.QUESTION_CIRCLE, className: styles.UsersImportTutoIcon }), _jsx("span", __assign({ className: styles.UsersImportTutoText }, { children: needHelpText }))] })), _jsx(Icons, { icon: E_ICONS.ARROW_RIGHT, className: styles.UsersImportTutoIconArrowImmersed })] })), _jsx("div", __assign({ className: tutoContentClass, style: { height: isTutoOpen ? heightOfTutorial : 0, marginTop: isTutoOpen ? undefined : 0 } }, { children: _jsxs("div", __assign({ ref: contentRef }, { children: [_jsx("p", __assign({ className: styles.tutoFormatText }, { children: formatText })), _jsx("br", {}), _jsx("p", { children: formatFirstLineText }), _jsxs("p", { children: [requiredColsText, " ", _jsx("strong", __assign({ className: styles.tutoRequiredHeaders }, { children: REQUIRED_CSV_FILE_HEADERS.join(', ') }))] }), _jsx("br", {}), _jsx("p", { children: groupsFormatText }), _jsx("p", { children: groupsFormatExampleText }), _jsxs("div", __assign({ className: styles.tutoExampleFormat }, { children: [_jsx("span", __assign({ className: styles.tutoExampleFormatText }, { children: "username;lastName;firstName;email;groups" })), _jsx("br", {}), _jsx("span", __assign({ className: styles.tutoExampleFormatText }, { children: "\"jsmith\";\"Smith\";\"John\";\"imjohn@smithmail.com\";\"Admin Utilisateurs, Acc\u00E8s aux dossiers en lecture\"" }))] })), _jsx("br", {}), _jsx("p", { children: _jsx("strong", { children: userModifiedAndCreatedText }) }), _jsx("p", { children: _jsx("strong", { children: userDeletedText }) })] })) }))] })));
};
